import { render } from "./BannerBotOniel.vue?vue&type=template&id=4ee22222&scoped=true"
import script from "./BannerBotOniel.vue?vue&type=script&lang=js"
export * from "./BannerBotOniel.vue?vue&type=script&lang=js"

import "./BannerBotOniel.vue?vue&type=style&index=0&id=4ee22222&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee22222"]])

export default __exports__